import React from 'react';
import { createSvgIcon } from '../IconBase';

export default createSvgIcon(<path d="M14.4 6L14 4H5v17h2v-7h5.6l.4 2h7V6z" />, 'AssistantPhoto');
